<button nbButton outline class="przycisk-kontakt" status="danger" size="small" title="{{ 'akcja.kontakt' | translate }}" [nbContextMenu]="kontaktMenu" [nbContextMenuTag]="kontaktMenuTag">
  <nb-icon icon="phone"></nb-icon>
  {{ 'akcja.kontakt' | translate }}
</button>